import {getAction} from "./index";


// 查询部门列表
export const listDept = (param) => getAction('/system/dept/list', param)

// 获取用户精简信息列表
export const listSimpleUsers = (param) => getAction('/system/user/list-all-simple', param)

// 查询用户列表
export const listUser = (param) => getAction('/system/user/page', param)

// 获取岗位精简信息列表
export const listSimplePosts = (param) => getAction('/system/post/list-all-simple', param)

// 获取部门精简信息列表
export const listSimpleDepts = (param) => getAction('/system/dept/list-all-simple', param)

// 查询角色列表
export const listRole = (param) => getAction('/system/role/page', param)
